import React from 'react'
import cv from '../imgAndpdf/cv.pdf'
import './Button.css'

function Button() {
  return (
    <div className='button-container'>
         <a href={cv} download className='btn-resume'>Download Resume</a>
         <a  href='../Contact/Contact.js' className='btn-msg'>Let's talk</a>
    </div>
  )
}

export default Button